import { Updatable } from '../../core/models/updatable'
import { Version } from '../../core/models/version'
import { VersionSummary } from '../../core/models/version-summary'
import { alias, AliasedConstructor } from '../../rest/decorators/alias'
import {
  DynamicBinding,
  SerialisationConfig,
} from '../../rest/utilities/serialisable'
import { BaseJobAllocation } from './base-job-allocation'
import { UpdateStatus } from './update-status'

export class Update extends Updatable {
  public static override serialisationConfig: SerialisationConfig =
    new SerialisationConfig(() => new Update(), {
      allocation: BaseJobAllocation.serialisationConfig,
      status: new SerialisationConfig(() => new UpdateStatus()),
      versions: new SerialisationConfig(() => new VersionSummary()),
      currentVersion: new SerialisationConfig(() => new Version()),
    })
  override mandatory = ['id']

  @alias('id')
  id!: number
  @alias('numeric_id')
  numericID!: number
  @alias('allocation')
  allocation!: BaseJobAllocation
  @alias('status')
  status!: UpdateStatus
  @alias('checks_completed')
  checksCompleted!: boolean
  @alias('outstanding_issues')
  outstandingIssues!: boolean
  @alias('requires_programming')
  requiresProgramming!: boolean
  @alias('reference')
  reference!: string
  @alias('coms_number')
  comsNumber!: string
  @alias('comments')
  comments!: string
  @alias('created_at')
  created!: Date
  @alias(['versions'])
  versions?: VersionSummary
  @alias('current_version')
  currentVersion!: Version | null
  constructor(aliases?: unknown) {
    super(
      aliases == null
        ? (Update as unknown as AliasedConstructor)._alias
        : Object.assign(
            {},
            (Update as unknown as AliasedConstructor)._alias,
            aliases
          )
    )
  }

  override serialise(): object {
    const data = super.serialise() as DynamicBinding
    if (data['first_version']) {
      delete data['first_version']
    }
    if (data['last_version']) {
      delete data['last_version']
    }
    if (data['current_version']) {
      delete data['current_version']
    }
    if (data['status']) {
      if (data['id']) {
        delete data['status']
      } else {
        data['status'] = this.status.value
      }
    }
    return data
  }

  static create<Data>(attrs: Data) {
    return new Update().update(attrs, Update.serialisationConfig)
  }
}
